import React from 'react';
import { StepProps } from '../../../types/RegistrationJourney';
import { PostcodeLookup, Stepper, useLangContext } from 'carrier-fe';
import { STEPS } from '../../../util/Constants';

function Step4({ form, pageLang, loading }: StepProps) {
   const { fields } = useLangContext();

   return (
      <Stepper.Step
         loading={loading}
         title={pageLang?.page?.steps?.[STEPS.STEP_4 - 1]?.title || 'Installer Details'}
         description={pageLang?.page?.steps?.[STEPS.STEP_4 - 1]?.description || ''}
      >
         <>
            {form?.Input({
               name: 'company_name',
               type: 'text',
               label: fields?.company_name || 'Company Name',
            })}
            <PostcodeLookup
               errors={{
                  address_id: form?.errors?.company_address_id,
                  address_line_1: form?.errors?.company_address_line_1,
                  address_line_2: form?.errors?.company_address_line_2,
                  address_line_3: form?.errors?.company_address_line_3,
                  town_city: form?.errors?.company_town_city,
                  state_county: form?.errors?.company_state_county,
                  postcode_zipcode: form?.errors?.company_postcode_zipcode,
                  local_authority_code: form?.errors?.company_local_authority_code,
                  country_code_iso_3: form?.errors?.company_country_code_iso_3,
                  sub_country_name: form?.errors?.company_sub_country_name,
               }}
               data={{
                  address_id: form?.store?.company_address_id || '',
                  sub_country_name: form?.store?.company_sub_country_name || '',
                  address_line_1: form?.store?.company_address_line_1 || '',
                  address_line_2: form?.store?.company_address_line_2 || '',
                  address_line_3: form?.store?.company_address_line_3 || '',
                  town_city: form?.store?.company_town_city || '',
                  state_county: form?.store?.company_state_county || '',
                  postcode_zipcode: form?.store?.company_postcode_zipcode || '',
                  local_authority_code: form?.store?.company_local_authority_code || '',
                  country_code_iso_3: form?.store?.company_country_code_iso_3 || '',
               }}
               setData={(value) => {
                  form?.setValues({
                     company_address_id: value?.address_id,
                     company_address_line_1: value?.address_line_1,
                     company_address_line_2: value?.address_line_2,
                     company_address_line_3: value?.address_line_3,
                     company_town_city: value?.town_city,
                     company_state_county: value?.state_county,
                     company_postcode_zipcode: value?.postcode_zipcode,
                     company_country_code_iso_3: value?.country_code_iso_3,
                     company_local_authority_code: value?.local_authority_code,
                     company_sub_country_name: value?.sub_country_name,
                  });
               }}
            />
            <div className="mt-4">
               {form?.Input({
                  name: 'company_gas_safe_number',
                  type: 'text',
                  label: fields?.company_gas_safe_number_unverified || 'Gas Safe Number (If known)',
               })}

            </div>
         </>
      </Stepper.Step>
   );
}

export default Step4;
